import React from "react";
import { styled } from "styled-components";

import { LoginItem } from "./login-item";
import { LOGIN_ASIDE_ITEMS } from "./login.constants";

const StyledAside = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
  padding: 0;

  a + a {
    margin: 9px 0 0;
  }
`;

export const LoginAside = () => {
  return (
    <StyledAside data-bdd="login-aside">
      {LOGIN_ASIDE_ITEMS.map(item => (
        <LoginItem
          key={item.TITLE}
          title={item.TITLE}
          message={item.MESSAGE}
          url={item.URL}
          target={item.TARGET}
          iconName={item.ICON}
        />
      ))}
    </StyledAside>
  );
};
